import { Component, OnInit } from '@angular/core';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import * as $ from 'jquery';
import { MatSnackBar } from '@angular/material';
import { CardInfo } from '../../../models/GL_Card_Info';
import { DariCalendarService } from '../../../services/DariCalendar';


@Component({
  selector: 'app-new-card',
  templateUrl: './new-card.component.html',
  styleUrls: ['./new-card.component.css']
})
export class NewCardComponent implements OnInit {
  constructor(private GL_MasterService: GL_MasterService,
              public snack: MatSnackBar,
              private DariCalendar: DariCalendarService) {

    this.student  ;
  }
  student: CardInfo;
  ngOnInit() { }

  studentID: any = "";
  isCreateCard: boolean = false;
  isCreateCard2: boolean = false;
  searchStudent() {
    console.log(this.studentID);
    this.GL_MasterService.getCardInfo(this.studentID).subscribe(r => {
      this.student = r;
      this.isCreateCard = this.student.isCreateCard;
      this.isCreateCard2 = this.student.isCreateCard2;
      this.printable = true;

      if (this.student.datePrintCard1)
        this.student.datePrintCard1_da = this.DariCalendar.PersianCalendar(new Date(this.student.datePrintCard1));
      if (this.student.datePrintCard2)
        this.student.datePrintCard2_da= this.DariCalendar.PersianCalendar(new Date(this.student.datePrintCard2));
    });
  }

  printable: boolean = false;
  printReport(pageNumber: number) {

    let card: CardInfo = {
      stuId: this.studentID,
      semesterId: this.student.semesterId,
      yearId: this.student.yearId,
      cardNumber: pageNumber,
      seasonId: this.student.seasonId,
      fullName: '',
      branchName: '',
      departmentName: '',
      firstName: '',
      lastName: '',
      datePrintCard1: '',
      datePrintCard2: '',
      datePrintCard1_da: '',
      datePrintCard2_da: '',
      avatarUrl: '',
      isCreateCard: false,
      isCreateCard2: false,
    };
    this.GL_MasterService.postPrintCard(card).subscribe(res => {

    });

    if (this.printable) {
      var content = $(`#printPaper${pageNumber} .body`).prop('outerHTML');
      var _style = $('style');
      var _script = $('script');
      var windowP = window.open('', '', '');
      windowP.document.write('<html><head><title>Print</title>');
      for (var i = 0; i < _style.length; i++)
        windowP.document.write(_style[i].outerHTML);
      windowP.document.write('</head><body class="rtl theme-purple menu_null">');
      windowP.document.write(content);
      for (var i = 0; i < _script.length; i++)
        windowP.document.write(_script[i].outerHTML);
      windowP.document.write('</body></html>');
      windowP.document.close();
      setTimeout(() => windowP.print(), 2000);
      //windowP.print();
      console.log(content);
    } else {
      this.snack.open('دیتا برای پرینت وجود ندارد.', '', { duration: 5000 });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/card/new-card/new-card.component.ts